import React, { useEffect, useState } from 'react';

const TypingEffect = ({ text, speed = 30 }) => {
  const [displayedText, setDisplayedText] = useState('');

  useEffect(() => {
    if (!text || typeof text !== 'string') {
      setDisplayedText('');
      return;
    }

    let index = 0;
    setDisplayedText('');
    const interval = setInterval(() => {
      setDisplayedText((prev) => prev + text.charAt(index));
      index++;
      if (index >= text.length) {
        clearInterval(interval);
      }
    }, speed);

    return () => clearInterval(interval);
  }, [text, speed]);

  return (
    <div>
      <span>{displayedText}</span>
    </div>
  );
};

export default TypingEffect;
